import * as React from "react";

const HeaderSearchInputIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="79" height="24" viewBox="0 0 79 24">
            <g id="Group_1542" data-name="Group 1542" transform="translate(-960 -69)">
                <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(956.5 68.5)">
                    <path
                        id="Path_4"
                        data-name="Path 4"
                        d="M18.722,11.611A7.111,7.111,0,1,1,11.611,4.5a7.111,7.111,0,0,1,7.111,7.111Z"
                        transform="translate(0 0)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                    />
                    <path
                        id="Path_5"
                        data-name="Path 5"
                        d="M28.842,28.842l-3.867-3.867"
                        transform="translate(-8.342 -8.342)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                    />
                </g>
                <text
                    id="Search"
                    transform="translate(984 87)"
                    fill="#fff"
                    stroke="rgba(0,0,0,0)"
                    stroke-width="1"
                    font-size="16"
                    font-family="Lato, NotoSans-Bold, Noto Sans"
                >
                    <tspan x="0" y="0">
                        Search
                    </tspan>
                </text>
            </g>
        </svg>
    );
};

export default React.memo(HeaderSearchInputIcon);
